"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var AccountResource = /** @class */ (function (_super) {
    tslib_1.__extends(AccountResource, _super);
    function AccountResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountResource.endpoint = '/accounts';
    AccountResource.MODEL_NAME = 'account';
    AccountResource.related = {
        parent: AccountResource,
    };
    return AccountResource;
}(base_1.default));
exports.default = AccountResource;
//# sourceMappingURL=account.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/account.js
// module id = XsBe
// module chunks = 0